<template>
	<div>
		<b-navbar fixed="top" variant="white" class="shadow">
			<div class="container">
				<b-navbar-brand :to="{ name: 'components' }">
					<img
						:src="require('@/assets/img/logo.jpg')"
						alt="Mobil"
						class="img-fluid"
						style="height: auto; width: 100%; max-width: 150px"
					/>
				</b-navbar-brand>
			</div>
		</b-navbar>
		<div
			class="container mt-4 text-dark"
			style="padding-top: 80px; padding-bottom: 40px"
		>
			<h1 class="mb-4 text-dark">LEGALES</h1>
			<p>
				<span
					>La empresa responsable de la promoci&oacute;n y/o din&aacute;mica
					es&nbsp;</span
				><span
					>IMAQUINANDO S.A. DE C.V. con domicilio en Av. Amores 1153 &ndash; 2
					Col del Valle Centro, Alcald&iacute;a Benito Ju&aacute;rez, C.P.
					03100, en la Ciudad de M&eacute;xico</span
				>
			</p>
			<p>
				<span
					>IMAQUINANDO S.A DE C.V. se reserva el derecho de rechazar o excluir a
					cualquier participante durante la din&aacute;mica por no reunir los
					requisitos descritos en las presentes bases y t&eacute;rminos de
					participaci&oacute;n, o contravenga las normas o finalidad de la
					din&aacute;mica. IMAQUINANDO S.A. DE C.V. no se responsabiliza de las
					posibles p&eacute;rdidas de datos por problemas de correo
					electr&oacute;nico y/o por el mal funcionamiento de Internet.
					&nbsp;</span
				>
			</p>
			<p>
				<span
					>IMAQUINANDO S.A. DE C.V. podr&aacute; suspender la din&aacute;mica
					y/o promoci&oacute;n y/o la entrega del incentivo sin responsabilidad
					alguna, si dicha suspensi&oacute;n fuera generada por caso fortuito o
					fuerza mayor y/o resultar&aacute; en observancia de alguna
					disposici&oacute;n emitida por cualquier autoridad competente donde se
					afecten los intereses del cliente y/o el responsable de la
					promoci&oacute;n y/o las empresas responsables de hacer efectivo la
					entrega del Incentivo. Por lo que en caso de ser necesario modificar
					el plazo y lugar de entrega del incentivo, se har&aacute; del
					conocimiento de cada acreedor a trav&eacute;s del correo
					electr&oacute;nico y conforme a los datos registrados por el cliente
					para llevar a cabo la din&aacute;mica.&nbsp;</span
				>
			</p>
			<p>
				<span
					>Si por causas ajenas al responsable de la Promoci&oacute;n se
					suspendiera, modificara, alterara o de cualquier forma se viera
					imposibilitado el acreedor para disfrutar del incentivo, el
					responsable de la promoci&oacute;n se reserva el derecho de otorgar
					opcionalmente alg&uacute;n incentivo igual o similar al incentivo al
					que se haya hecho acreedor. De igual forma se proceder&aacute; en los
					casos que existieran actos pol&iacute;ticos, sociales o de salud que
					pusieran en peligro la integridad f&iacute;sica de cualquiera de los
					acreedores de los incentivos.&nbsp;</span
				>
			</p>
			<p>
				<span
					>En los casos mencionados, el responsable de la promoci&oacute;n,
					publicar&aacute; a trav&eacute;s de sus medios impresos y/o a
					trav&eacute;s de su p&aacute;gina web los motivos en que se fundamenta
					la realizaci&oacute;n de cualquiera de los actos establecidos en el
					presente p&aacute;rrafo para dar aviso al p&uacute;blico consumidor o
					sus clientes.</span
				>
			</p>
			<p>
				<span
					>Todos los participantes autorizan el uso de los datos proporcionados,
					as&iacute; como las im&aacute;genes, videos y fotos que se tomen en la
					entrega del incentivo y durante el desarrollo de la din&aacute;mica
					para ser utilizadas para contenido en redes sociales, televisivo,
					radio y prensa por parte de los organizadores.</span
				>
			</p>
			<p>
				<span
					>Las medidas de la pista del Aut&oacute;dromo Hermanos
					Rodr&iacute;guez, las medidas del monoplaza de Scuderia RedBull modelo
					RB16B y las respuestas correctas est&aacute;n revisadas y autorizadas
					bajo una FE DE HECHOS del notario P&uacute;blico 249 de la Ciudad de
					M&eacute;xico, Lic. Ra&uacute;l Rodr&iacute;guez Pi&ntilde;a.</span
				>
			</p>
			<p>
				<span
					>En caso de queja, acudir a la Procuradur&iacute;a Federal del
					Consumidor, o bien comunicarse al tel&eacute;fono 55&nbsp;</span
				><span>5625 6700</span>
			</p>
			<p>
				<span
					>Aviso ante Profeco folio n&uacute;mero: PFC.C.A./000978-2021</span
				>
			</p>
			<p>
				<span
					>Para &nbsp;cualquier &nbsp;aclaraci&oacute;n o &nbsp;
					informaci&oacute;n &nbsp;referente a esta &nbsp;din&aacute;mica &nbsp;
					o &nbsp;de &nbsp;resultados &nbsp; del &nbsp;mismo, comunicarse al
					tel&eacute;fono 01 (5556884444 y 5591972000) o escribir al
					correo&nbsp;</span
				><a href="mailto:hola@imakinando.mx"><span>hola@imakinando.mx</span></a
				><span
					>&nbsp; (En ambos casos el horario de atenci&oacute;n ser&aacute; de
					Lunes a Viernes de 09:00 hrs a 18:00 hrs).</span
				>
			</p>
			<p>
				<span
					>Vigencia de la promoci&oacute;n es del 20 de agosto del 2021 al 25 de
					octubre del 2021</span
				>
			</p>
			<p><span>El incentivo no es reembolsable en dinero.&nbsp;</span></p>
			<p>
				<span
					>La zona geogr&aacute;fica de la promoci&oacute;n ser&aacute; toda la
					Rep&uacute;blica Mexicana. &nbsp;&nbsp;</span
				>
			</p>
			<p>
				<span
					>Acceso libre y gratuito al p&uacute;blico en general al evento del
					sorteo, con registro previo en la recepci&oacute;n se requiere de
					identificaci&oacute;n oficial vigente.</span
				>
			</p>
			<p>
				<span
					>Comunicaci&oacute;n de la promoci&oacute;n: carteles promocionales,
					correo electr&oacute;nico y en el interior de las gasoliner&iacute;as
					participante, as&iacute; como en Redes Sociales.</span
				>
			</p>
			<p>
				<span
					>El total de tickets registrados y folios participantes de cada
					cliente ser&aacute; ilimitado, siendo los que resulten registrados
					durante el per&iacute;odo de la promoci&oacute;n seg&uacute;n las
					compras y recompras de gasolina en las estaciones de servicio MOBIL
					participantes.</span
				>
			</p>
			<p><span>Limitado a 10 Incentivos.&nbsp;</span></p>
		</div>
		<FooterBack></FooterBack>
	</div>
</template>
<script>
import FooterBack from "./components/FooterBack";
export default {
	name: "legales",
	components: {
		FooterBack,
	},
};
</script>
